export const ConsonantBasic = [

    {
        id: 1,
        korean: 'ㄱ',
        english: 'g/k',
        description: 'g as in go (initially can sound like k)'
    },
        {
        id: 2,
        korean: 'ㄴ',
        english: 'n',
        description: 'n as in no'
    },
        {
        id: 3,
        korean: 'ㄷ',
        english: 'd/t',
        description: 'd as in dog (initially can sound like t)'
    },
        {
        id: 4,
        korean: 'ㄹ',
        english: 'r/l',
        description: 'r as in run (between vowels), l at the end of a syllable'
    },
        {
        id: 5,
        korean: 'ㅁ',
        english: 'm',
        description: 'm as in mom'
    },
        {
        id: 6,
        korean: 'ㅂ',
        english: 'b/p',
        description: 'b as in bat (initially can sound like p)'
    },
        {
        id: 7,
        korean: 'ㅅ',
        english: 's',
        description: 's as in see (before i, sounds like sh)'
    },
        {
        id: 8,
        korean: 'ㅇ',
        english: 'ng / silent',
        description: 'silent at the start of a syllable, ng at the end like song'
    },
        {
        id: 9,
        korean: 'ㅈ',
        english: 'j',
        description: 'j as in jar'
    },
        {
        id: 10,
        korean: 'ㅊ',
        english: 'ch',
        description: 'ch as in chop'
    },
        {
        id: 11,
        korean: 'ㅋ',
        english: 'k',
        description: 'aspirated k as in kill'
    },
            {
        id: 12,
        korean: 'ㅌ',
        english: 't',
        description: 'aspirated t as in top'
    },
            {
        id: 13,
        korean: 'ㅍ',
        english: 'p',
        description: 'aspirated p as in pot'
    },
            {
        id: 14,
        korean: 'ㅎ',
        english: 'h',
        description: 'h as in hat'
    }
    ];

export const ConsonantComplex =[

    {
        id: 1,
        korean: 'ㄲ',
        english: 'kk',
        description: 'tense k, stronger than ㄱ'
    },
    {
        id: 2,
        korean: 'ㄸ',
        english: 'tt',
        description: 'tense t, stronger than ㄷ'
    },
    {
        id: 3,
        korean: 'ㅃ',
        english: 'pp',
        description: 'tense p, stronger than ㅂ'
    },
    {
        id: 4,
        korean: 'ㅆ',
        english: 'ss',
        description: 'tense s, stronger than ㅅ'
    },
        {
        id: 5,
        korean: 'ㅉ',
        english: 'jj',
        description: 'tense j, stronger than ㅈ'
    }

    ];
    export const VowelBasic = [

    {
        id: 1,
        korean: "ㅏ",
        english: "a",
        description: ""
    },
    {
        id: 2,
        korean: "ㅑ",
        english: "ya",
        description: ""
    },
    {
        id: 3,
        korean: "ㅓ",
        english: "eo",
        description: ""
    },
    {
        id: 4,
        korean: "ㅕ",
        english: "yeo",
        description: ""
    },
    {
        id: 5,
        korean: "ㅗ",
        english: "o",
        description: ""
    },
    {
        id: 6,
        korean: "ㅛ",
        english: "yo",
        description: ""
    },
    {
        id: 7,
        korean: "ㅜ",
        english: "u",
        description: ""
    },
    {
        id: 8,
        korean: "ㅠ",
        english: "yu",
        description: ""
    },
    {
        id: 9,
        korean: "ㅡ",
        english: "eu",
        description: ""
    },
    {
        id: 10,
        korean: "ㅣ",
        english: "i",
        description: ""
    }

];

export const VowelComplex = [

    {
        id: 1,
        korean: "ㅐ",
        english: "ae",
        description: "ae as in care"
    },
    {
        id: 2,
        korean: "ㅒ",
        english: "yae",
        description: "yae as in yeah"
    },
    {
        id: 3,
        korean: "ㅔ",
        english: "e",
        description: "e as in red"
    },
    {
        id: 4,
        korean: "ㅖ",
        english: "ye",
        description: "ye as in yes"
    },
    {
        id: 5,
        korean: "ㅘ",
        english: "wa",
        description: "wa as in water"
    },
    {
        id: 6,
        korean: "ㅙ",
        english: "wae",
        description: "we as in wedding"
    },
    {
        id: 7,
        korean: "ㅚ",
        english: "oe",
        description: ""
    },
    {
        id: 8,
        korean: "ㅝ",
        english: "wo",
        description: "we/way between wet and wait"
    },
    {
        id: 9,
        korean: "ㅞ",
        english: "we",
        description: "we as in west"
    },
    {
        id: 10,
        korean: "ㅢ",
        english: "ui",
        description: "said like eui"
    },
    {
        id: 11,
        korean: "ㅟ",
        english: "wi",
        description: "wi as in week"
    }

];

